import React from 'react';

import { Block } from './Block.jsx';
import PrivateView from './PrivateView.jsx';
import Token from './Token.jsx';

const Inventory = {
    edition: function (inventory) {
        let edition;
        if (inventory.editions && inventory.editions.length > 0) {
            edition = inventory.editions[0];
        }
        return edition;
    },

    // Reads a cell design back into the flags the constructors consume.
    Visibility: {
        designHasToken: (design, token) => typeof design === 'string' && design.indexOf(`token="${token}"`) >= 0,

        // Inner text of a design string, DOM-free so it's safe server-side.
        designText: (design) => typeof design === 'string' ? design.replace(/<[^>]*>/g, '').trim() : undefined,

        // cta carries its label ({ text }) when present so the popup mirrors the cell.
        deriveVisibility: (cell) => {
            const blocks = cell && cell.desktop && cell.desktop.blocks;
            const find = (id) => {
                const hit = Block.findBlockConfig((b) => b.id === id, blocks);
                return hit ? hit.blocks[hit.index] : undefined;
            };
            const detailsDesign = find(PrivateView.cellTextId(PrivateView.CellField.Details))?.config?.block?.design;
            const ctaBlock = find(PrivateView.ctaId);
            return {
                availability: find(PrivateView.cellTextId(PrivateView.CellField.Availability)) != undefined,
                cta: ctaBlock ? { text: Inventory.Visibility.designText(ctaBlock.config?.block?.design) } : undefined,
                dimensions: Inventory.Visibility.designHasToken(detailsDesign, Token.Dimensions),
                medium: Inventory.Visibility.designHasToken(detailsDesign, Token.Medium),
                // Current configs emit PriceWithoutOverride; older ones used Price.
                price: Inventory.Visibility.designHasToken(detailsDesign, Token.PriceWithoutOverride)
                    || Inventory.Visibility.designHasToken(detailsDesign, Token.Price)
            };
        }
    },

    SubType: {
        options: (type) => {
            switch (type) {
                case Inventory.Type.Jewelry:
                    return [
                        { display: 'All' },
                        { value: '0', display: 'Ring' },
                        { value: '1', display: 'Necklace' },
                        { value: '2', display: 'Bracelet' },
                        { value: '3', display: 'Watch' },
                        { value: '4', display: 'Earrings' },
                        { value: '5', display: 'Cufflinks' },
                        { value: '6', display: 'Brooches' },
                        { value: '7', display: 'Other' }
                    ]
                case Inventory.Type.Furniture:
                    return [
                        { display: 'All' },
                        { value: '8', display: 'Chair' },
                        { value: '9', display: 'Sofa' },
                        { value: '10', display: 'Bench' },
                        { value: '11', display: 'Storage' },
                        { value: '12', display: 'Table' },
                        { value: '7', display: 'Other' }
                    ]
                case Inventory.Type.Lighting:
                    return [
                        { display: 'All' },
                        { value: '13', display: 'Wall Light and Sconce' },
                        { value: '14', display: 'Table Lamp' },
                        { value: '15', display: 'Floor Lamp' },
                        { value: '16', display: 'Chandelier/Pendant' },
                        { value: '7', display: 'Other' }
                    ]
                case Inventory.Type.Decor:
                    return [
                        { display: 'All' },
                        { value: '17', display: 'Rug and Carpet' },
                        { value: '18', display: 'Decorative Object' },
                        { value: '19', display: 'Mirror' },
                        { value: '20', display: 'Sculpture' },
                        { value: '21', display: 'Candle' },
                        { value: '22', display: 'Tableware' },
                        { value: '7', display: 'Other' }
                    ]
            }
        }
    },

    Type: {
        Artwork: '0',
        Merchandise: '1',
        Jewelry: '5',
        Furniture: '6',
        Lighting: '7',
        Decor: '8'
    }
};
export default Inventory;

function Subtitle(props) {
    let edition;
    const temp = Inventory.edition(props.data);
    if (temp && temp.edition && temp.edition.toString().length > 0) {
        edition = ` (${temp.edition})`
    }
    let date;
    if (props.data.date && props.data.date.toString().length > 0) {
        date = `, ${props.data.date}`;
    }
    return (
        <span className="artwork__info__item">
            <span className="artwork__info__item__edition">{edition}</span><span className="artwork__info__item__date">{date}</span>
        </span>
    );
}

export { Subtitle };